module.exports = __webpack_public_path__ + "static/media/boat-img-3.d3fa0a78.jpg";